import React from "react";

const Permission = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      d="M14.039 9.747l8.007 8.007-.068 3.243a.4.4 0 01-.376.391l-3.84.226-.011-2.143-2.042.139.013-1.983-2.048.118.237-2.113-2.675.123L9.57 14.09c-1.952.527-4.06.074-5.52-1.388-2.237-2.236-2.113-5.986.276-8.376 2.39-2.389 6.14-2.513 8.376-.276 1.506 1.505 1.942 3.696 1.337 5.697zm-8.567-2.05c.575.576 1.54.544 2.154-.07.615-.615.647-1.58.072-2.155-.576-.576-1.54-.544-2.155.07-.615.616-.647 1.58-.071 2.156z"
      fillRule="nonzero"
    />
  </svg>
);

export default Permission;
